import { TabItem } from './style';
const Tab = ({ label, activeTab, keyId, setActiveTab }) => {
  return (
    <TabItem onClick={() => setActiveTab(keyId)} active={activeTab == keyId}>
      {label}
    </TabItem>
  );
};

export default Tab;
